import jsPDF from "jspdf";
import { logoBase64 } from "../../../public/assets/logoBase64";
import { ClaimResponse, Coverage, Vehicle } from "../interfaces/accidents.interface";


interface params {
  data: ClaimResponse,
  usuario: string,
  document: string;
  vehicle: Vehicle;
  coverage: Coverage;
  lossDate: string;
  emailAddress: string;
  phoneNumber: string
}
export const descargarConsultaAccidente = ({ data, usuario, document, vehicle, coverage, lossDate, emailAddress, phoneNumber }: params) => {
  const doc = new jsPDF({ orientation: "landscape" }) as any; // Orientación landscape

  let currentY = 15; // Posición inicial en la página

  // Header de la página

  const pageHeader = (doc: any) => {
    doc.addImage(logoBase64, "PNG", 10, 10, 40, 13);
    doc.setFontSize(16);
    doc.text(`Reclamación Aviso de accidentes - Plataforma Intermediario`, 55, 15);
    doc.setFontSize(12);
    doc.text(`${usuario}`, 55, 20);
    doc.text(`${new Date().toLocaleDateString('es-ES', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    })}`, 55, 25);

  }
  doc.autoTable({
    didDrawPage: () => pageHeader(doc),
  });

  const head = [
    [`Reclamo No. ${data.eventNumber}`, `Status: ${data.eventStatusDescription}`],
  ]

  doc.autoTable({
    startY: currentY + 12,
    body: head,
    margin: { left: 10 },
    didParseCell: function (row: any) {
      // Aplica estilos solo a la primera fila del body
      if (row.row.index === 0 && row.section === 'body') {
        // row.cell.styles.fillColor = [0, 85, 140]; // Color de fondo azul
        row.cell.styles.valign = 'bottom'; // Grosor del borde
        row.cell.styles.lineWidth = 0; // Grosor del borde
        row.cell.styles.lineWidth = { bottom: 1 }; // Grosor del borde
        row.cell.styles.lineColor = [255, 165, 0]; // Borde naranja (RGB)
        row.cell.styles.fillColor = [255, 255, 255]; // Fondo blanco opcional
        row.cell.styles.textColor = [0, 0, 0]; // Texto blanco
        row.cell.styles.fontStyle = 'bold'; // Texto en negrita
        row.cell.styles.fontSize = 16; // Texto en negrita
      }
    }
  })

  const body = [
    ['Nombre del asegurado', data.clientInfo.claimantName],
    ['Núm. de identificación', `${document}: ${data.clientInfo.idNumber}`],
    ['Núm. de Póliza', data.policyNumber],
    ['Correo', emailAddress],
    ['Celular', phoneNumber],
    ['', ''],
    ['Fecha del siniestro', lossDate],
    ['Nombre del conductor', data.driverName],
    ['Vahículo', `${vehicle!.makeModelDescription + "/" + vehicle!.registrationNumber + " /" +
      vehicle!.vinNumber}`],
    ['Tipo de siniestro', coverage.shortDescription],
    ['Detalles del siniestro', data.eventDescription],
    ['', ''],
    ['¿Hubo lesiones?', data.hasInjured ? 'Sí' : 'No'],
    ['¿Vehículo inmóvil?', data.stationaryVehicle ? 'Sí' : 'No'],
  ]

  doc.autoTable({
    startY: doc.lastAutoTable.finalY + 5,
    body: body,
    styles: {
      fontSize: 10,  // Font size for the table content
      rowHeight: 5
    },
    margin: { left: 10 },
    didParseCell: (data: any) => {
      if (data.row.index >= 0) {
        data.cell.styles.fillColor = [255, 255, 255]; // Fondo blanco opcional
        data.cell.styles.textColor = [0, 0, 0]; // Texto blanco
      }
      if (data.column.index === 0) {
        data.cell.styles.fontStyle = 'bold';
      }
    }
  });

  doc.save(`Reclamación ${data.eventNumber} - Aviso de accidentes.pdf`);

}
